export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./loadingBtn.vue?vue&type=template&id=3e5bfdd0&"


//////////////////
// WEBPACK FOOTER
// ./src/components/btns/loadingBtn.vue?vue&type=template&id=3e5bfdd0&
// module id = null
// module chunks = 